<template>
  <div class="container policies-page">
    <div class="row d-flex align-items-center">
      <div class="col-12" v-if="isLoading">
        <h2 class="placeholder-glow">
          <span class="placeholder col-3"></span>
        </h2>
        <p class="placeholder-glow">
          <span class="placeholder col-8"></span>
          <span class="placeholder col-8"></span>
          <span class="placeholder col-8"></span>
          <span class="placeholder col-8"></span>
        </p>
      </div>
      <div class="col-12" v-else>
        <div class="polices_header text-center">
          <h1>{{ returnContent?.name }}</h1>
        </div>
        <div class="policies_content">
          <div v-html="returnContent?.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import LayoutService from "@/services/layout";
import handleError from "@/helper/handleError";
// ========================== initialize data =================
export default defineComponent({
  name: "PoliciesView",
  setup() {
    interface Policy {
      name: string;
      text: string;
      enabled: Boolean;
      id: string;
    }
    const returnContent = ref<Policy | null>(null);
    const route = useRoute();
    const isLoading = ref(true);

    // Get from URL first, then fall back to localStorage
    const productID = (route.query.productID as string) || localStorage.getItem('productID');

    // ===================== Methods ===============
    // Get all policy data and filter by route ID
    const getAllPolicyData = () => {
      console.log(productID)
      isLoading.value = true;
      LayoutService.getPolicies(productID)
        .then((res: any) => {
          isLoading.value = false;
          const response = res.data.data.policies;
          if (Array.isArray(response)) {
            const policyId = route.params.id;
            returnContent.value =
              response.find((policy: Policy) => policy.id === policyId) || null;
          }
        })
        .catch((err: any) => {
          isLoading.value = false;
          handleError(err);
        });
    };
    // ==================== onMounted =================
    onMounted(() => {
      getAllPolicyData();
    });

    return {
      isLoading,
      returnContent,
      getAllPolicyData,
      productID
    };
  },
});
</script>
<style lang="scss" scoped>
.policies-page {
  .row {
    min-height: calc(100vh - 140px);
  }
  .polices_header {
    margin-top: 50px;

    h1 {
      font-size: 32px;
      font-weight: 600;
      @media (max-width: 768px) {
        font-size: 24px;
      }
    }
  }

  .policies_content {
    margin-top: 30px;

    > div {
      max-width: 80%;
      margin: auto;

      @media (max-width: 768px) {
        max-width: 100%;
      }
    }
  }
  .placeholder {
    min-height: .5em !important;
  }
}
</style>
